import { Routes } from '@angular/router';

export const TEACHERS_ROUTES: Routes = [
  {
    path: 'create',
    loadComponent: () =>
      import('../teachers/teacher-create-page/teacher-create.page').then(
        (c) => c.TeacherCreatePage,
      ),
  },
  {
    path: ':teacherId',
    loadComponent: () =>
      import('../teachers/teacher-details-page/teacher-details.page').then(
        (c) => c.TeacherDetailsPage,
      ),
  },
  {
    path: ':teacherId/edit/academics',
    loadComponent: () =>
      import('../teachers/teacher-academics-edit-page/teacher-academics-edit.page').then(
        (c) => c.TeacherEditAcademicsPage,
      ),
  },
  {
    path: ':teacherId/edit/career',
    loadComponent: () =>
      import('../teachers/teacher-career-edit-page/teacher-career-edit.page').then(
        (c) => c.TeacherEditCareerPage,
      ),
  },
  {
    path: ':teacherId/edit/contact',
    loadComponent: () =>
      import('../teachers/teacher-contact-edit-page/teacher-contact-edit.page').then(
        (c) => c.TeacherEditContactPage,
      ),
  },
  {
    path: ':teacherId/edit/passport',
    loadComponent: () =>
      import('./teacher-passport-edit-page/teacher-passport-edit.page').then(
        (c) => c.TeacherEditPassportPage,
      ),
  },
  {
    path: ':teacherId/edit/subjects',
    loadComponent: () =>
      import('../teachers/teacher-subjects-edit-page/teacher-subjects-edit.page').then(
        (c) => c.TeacherEditSubjectsPage,
      ),
  },
  {
    path: ':teacherId/edit/picture',
    loadComponent: () =>
      import('../teachers/teacher-picture-edit-page/teacher-picture-edit.page').then(
        (c) => c.TeacherEditPicturePage,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('../teachers/teacher-list-page/teacher-list.page').then((c) => c.TeacherListPage),
  },
  { path: '**', redirectTo: '' },
];
